import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NavHeading from './NavHeading';
import Social from './Social';
import styles from './footer.module.scss';

const Footer = ({footerLinks}) => (
  <footer className={classNames('footer', styles.Footer)}>
    <div className="container container-1040">
      <div className="columns">
        <div className="column is-3">
          <a className={styles.Footer__logo} href="https://www.teamgantt.com/">
            TeamGantt
          </a>
        </div>
        {footerLinks.map(({heading, links}, i) => (
          <div className="column is-3" key={`footer-links-${i}`}>
            <NavHeading text={heading} />
            <ul>
              {links.map(({title, href}, j) => (
                <li className={styles.Footer__navItem} key={`link-${i}-${j}`}>
                  <a
                    className={classNames(
                      styles.Footer__link,
                      'is-size-4',
                      'has-text-weight-bold'
                    )}
                    href={href}
                  >
                    {title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className={classNames('columns', styles.Footer__subFooter)}>
        <div className="column is-4 is-size-7 has-text-grey-light">
          <p>&copy; TeamGantt 2022</p>
        </div>
        <div className="column is-4">
          <ul className={classNames('is-flex', styles.Footer__subLinks)}>
            <li>
              <a
                className="has-text-grey-light is-size-7"
                href="https://www.teamgantt.com/privacy-policy/"
              >
                Privacy
              </a>
            </li>
            <li>
              <a
                className="has-text-grey-light is-size-7"
                href="https://www.teamgantt.com/security/"
              >
                Security
              </a>
            </li>
            <li>
              <a
                className="has-text-grey-light is-size-7"
                href="https://www.teamgantt.com/terms/"
              >
                Terms
              </a>
            </li>
          </ul>
        </div>
        <div className="column is-4">
          <Social />
        </div>
      </div>
    </div>
  </footer>
);

Footer.propTypes = {
  footerLinks: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string.isRequired,
      links: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          href: PropTypes.string.isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.js